var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNotice = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19V3C18 2.44772 17.5523 2 17 2H16.46C16.1977 2.0011 15.9463 2.10526 15.76 2.29L12.76 5.24C11.6334 6.36799 10.1042 7.00125 8.51 7H5C3.34315 7 2 8.34315 2 10V12C2 13.6569 3.34315 15 5 15H8.51C10.0869 15.0119 11.5957 15.6442 12.71 16.76L15.71 19.71C15.8963 19.8947 16.1477 19.9989 16.41 20H17C17.5523 20 18 19.5523 18 19ZM22 11C22 11.8655 21.7193 12.7076 21.2 13.4C21.1034 13.5048 20.9675 13.5643 20.825 13.5643C20.6825 13.5643 20.5466 13.5048 20.45 13.4L19.73 12.68C19.5627 12.511 19.5376 12.2476 19.67 12.05C20.1096 11.3825 20.1096 10.5175 19.67 9.85C19.5376 9.65245 19.5627 9.38902 19.73 9.22L20.45 8.5C20.5526 8.3966 20.6945 8.34201 20.84 8.35C20.9817 8.36649 21.1111 8.4384 21.2 8.55C21.7297 9.25604 22.0109 10.1174 22 11ZM12 20.92V21.5C12 21.7761 11.7761 22 11.5 22H9.57C9.21693 21.9999 8.89006 21.8137 8.71 21.51L6.43 17.71C6.24541 17.4036 6.12308 17.0638 6.07 16.71H8.51C9.04785 16.7071 9.58112 16.809 10.08 17.01L10.5 19.76C10.6392 20.0632 10.9206 20.277 11.25 20.33L11.58 20.39C11.8364 20.4309 12.0188 20.6611 12 20.92Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotice, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notice.8ccf5eb0.svg";
export { ForwardRef as ReactComponent };